export default __webpack_public_path__ + "static/media/windows.e53456bb.svg";